import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

const schema = z.object({
  adminUserId: z.string(),
  dataPolicy: z.literal('Hipaa').or(z.literal('Unrestricted')),
  estimatedSize: z.number(),
  industry: z.string().optional(),
  isEnabled: z.boolean(),
  isPayThroughApp: z.boolean(),
  name: z.string().min(1, { message: 'Name is required' }),
  showLiveChat: z.boolean(),
  website: z.string().optional(),
});

export type OrganizationEditFormContextType = Required<z.infer<typeof schema>>;

type OrganizationEditFormProviderProps = {
  defaultValues?: OrganizationEditFormContextType;
  children: React.ReactNode;
};

export const OrganizationEditFormProvider = ({
  children,
  defaultValues,
}: OrganizationEditFormProviderProps) => {
  const methods = useForm<OrganizationEditFormContextType>({
    mode: 'onChange',
    resolver: zodResolver(schema),
    defaultValues,
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
